import React, { useEffect, useState } from 'react';
import { makeStyles } from "@utilities/theme_utilities";

interface Props {
  name: string;
  disabled?: boolean;
  color?: string;
  width?: number;
  style?: React.CSSProperties | undefined;
  className?: string;
  flashing?: boolean;
  small?: boolean;
  onClick?: (event: React.MouseEvent<HTMLSpanElement>) => void;
  onMouseDown?: (event: React.MouseEvent<HTMLSpanElement>) => void;
}

export default function ButtonBox({ 
  name,
  disabled = false,
  color,
  width = -1,
  style = {},
  className = "",
  flashing = false,
  small = false,
  onClick,
  onMouseDown,
}: Props) {
  const [is_flashing, setFlashing] = useState(flashing);
  const [is_disabled, setDisabled] = useState(disabled);

  useEffect(() => {
    setFlashing(flashing);
  }, [flashing]);
  
  useEffect(() => {
    setDisabled(disabled);
  }, [disabled]);

  const useStyles = makeStyles()((theme) => {
    return ({
      root: {
        color: color ? color : theme.palette.primary.main,
        borderColor: color ? color : theme.palette.primary.main,
        lineHeight: 2.5,
        '&:hover': {
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.primary.main,
        },
        '&.disabled': {
          color: theme.palette.primary.contrastText,
          backgroundColor: "gray",
        },
        '&:img': {
          filter: "brightness(0) invert(1)"
        }
      },
    });
  });

  const { classes, cx } = useStyles();
  let my_className = `${className} labs_button${is_flashing ? " Flashing" : ""}${is_disabled ? " disabled" : ""}`;

  const handleClick = (event: React.MouseEvent<HTMLSpanElement>) => {
    if (!disabled && onClick) {
      onClick(event);
    }
  };
    
  return (
    <span className="centered" style={{ display: "inline-block", width: (width > 0 ? `${width}px` : "100%") }}>
      <span
        style={{ display: "inline-block", width: "100%", ...style }}
        className={cx(classes.root, my_className)}
        onClick={handleClick}
        onMouseDown={onMouseDown}
      >
        {name}
      </span>
    </span>
  );
}